import { render, staticRenderFns } from "./GridMatchButtons.vue?vue&type=template&id=52568792&scoped=true&"
import script from "./GridMatchButtons.vue?vue&type=script&lang=js&"
export * from "./GridMatchButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52568792",
  null
  
)

export default component.exports